import React, { useEffect } from "react";
import { Alert, AlertTitle } from "@material-ui/lab";
import {
  Card,
  CardContent,
  CardHeader,
  Chip,
  Container,
  Divider,
  makeStyles,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  getPurchaseRequestJobAdmin,
  getPurchaseRequestJobs,
} from "src/redux/actions/purchaseRequest.action";
import MaterialTable from "material-table";

import _ from "lodash";
import { blue, blueGrey, green } from "@material-ui/core/colors";
import Page from "src/components/Page";

import { hasRole } from "src/utils/Auth";
import currencyJS from "currency.js";
import Moment from "moment";
import StatusLabel from "src/components/StatusLabel";
import moment from "moment";
import { httpClient } from "src/utils/HttpClient";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
}));

export default function PurchaseJobComponent() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();

  const {
    result: { countryid },
  } = useSelector((state) => state.loginReducer);

  const { authorizePR } = useSelector((state) => state.authorizationReducer);
  const { purchaseRequestJobs } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  if (purchaseRequestJobs.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert —{" "}
          <strong>Get Purchase Requisition Job!</strong>
        </Alert>
      </div>
    );
  }

  const sumTotalPrice = (value) => {
    let totalAmount = _(value.PR_D_JOBs)
      .groupBy("PRHIDX")
      .map((objs, key) => {
        return _.sumBy(objs, "AMOUNT");
      })
      .value();

    let totalExpense = _(value.PR_EXPENSEs)
      .groupBy("PRHIDX")
      .map((objs, key) => {
        return _.sumBy(objs, "AMOUNT");
      })
      .value();

    return Number(totalAmount) + Number(totalExpense);
  };

  return (
    <Page className={classes.root} title="Purchase Requisition List Job">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            subheader="For the purchase process to transaction on the system."
            title="Purchase Requisition Job"
          />
          <Divider />
          <CardContent>
            <MaterialTable
              title
              isLoading={purchaseRequestJobs.isLoading}
              columns={[
                {
                  title: "PR NO.",
                  field: "PR_NO",
                },
                {
                  title: "Request Date",
                  field: "CREATED_DATE",
                  type: "date",
                  render: (rowData) =>
                    Moment(rowData.CREATED_DATE).format("DD-MMM-YY"),
                },
                {
                  title: "Post Date",
                  field: "POSTED_DATE",
                  type: "date",
                  render: (rowData) =>
                    Moment(rowData.POSTED_DATE).format("DD-MMM-YY"),
                },
                { title: "Requester", field: "CREATED_NAME" },
                {
                  title: "Total Price",
                  field: "TOTAL_PRICE",
                  render: (rowData) => {
                    return currencyJS(sumTotalPrice(rowData), {
                      precision: 2,
                      symbol: "",
                    }).format();
                  },
                  filtering: false,
                },
                {
                  title: "Status",
                  field: "PR_STATUS",
                  lookup: {
                    50: "PURCHASING IN PROGRESS",
                    51: "VERIFIED PR",
                    53: "CONTRACT IS NOT REQUIRED",
                    60: "PURCHASE TASK IS COMPLETED",
                    70: "HELD BY PURCHASER",
                    80: "REJECTED BY PURCHASER",
                    100: "PO GENERATED",
                  },
                  render: (rowData) => (
                    <StatusLabel status={rowData.PR_STATUS} />
                  ),
                },
                {
                  title: "Assigned Date",
                  field: "ASSIGN_DATE",
                  type: "date",
                  render: (rowData) => {
                    if (rowData.ASSIGN_DATE) {
                      return Moment(rowData.ASSIGN_DATE).format("DD-MMM-YY");
                    } else {
                      return null;
                    }
                  },
                  customFilterAndSearch: (term, rowData) => {
                    return (
                      Moment(term).format("DD-MMM-YY") ===
                      Moment(rowData.ASSIGN_DATE).format("DD-MMM-YY")
                    );
                  },
                },
                {
                  title: "Assign To",
                  field: "ASSIGN_PURCHASE_NAME",
                },
              ]}
              // data={purchaseRequestJobs.data}
              data={(query) =>
                new Promise((resolve, reject) => {
                  let url = `/purchase-request/job-list/${countryid}?`;

                  url += "&per_page=" + query.pageSize;
                  url += "&page=" + query.page;
                  url += "&search=" + query.search;

                  if (query.filters.length) {
                    query.filters.map(({ column, value }) => {
                      if (column.field === "CREATED_DATE") {
                        value = moment(value).format("YYYY-MM-DD");
                      }
                      url += `&${column.field}=${value}`;
                    });
                  }

                  if (query.orderBy) {
                    url += `&orderby=${query.orderBy.field},${query.orderDirection}`;
                  }

                  httpClient.get(url).then(({ data }) => {
                    resolve({
                      data: data.rows,
                      page: query.page,
                      totalCount: data.count,
                    });
                  });
                })
              }
              actions={[
                (rowData) => ({
                  icon: "edit",
                  onClick: (event, rowData) => {
                    history.push(`purchase-edit-job/${rowData.PRHIDX}`);
                  },
                }),
              ]}
              options={{
                filtering: true,
                showFirstLastPageButtons: false,
              }}
              style={{
                width: "100%",
              }}
            />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
